import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';
import { useAgGrid } from '@tassat/ag-grid';
import { ToolbarButton } from '@tassat/button';
import { ACGWithMappedUsers } from '@tassat/fred-extended-definitions';
import { Export as ExportIcon } from '@tassat/icon';
import React from 'react';

import history from 'Lib/browserHistory';
import { download } from 'Lib/exportHelper';
import { formatEpochDate, sortAcgAlphaNumeric } from 'Lib/stringHelpers';
import 'SharedComponents/agGrid/styles/agGridOverrides.css';

import { ACGNumbersColumnDefs } from './ACGNumberColumnDef';

import type { AcgNumberGridProps } from '.';

export function ACGNumberGrid(props: AcgNumberGridProps) {
    const {
        classes,
        location,
        filterModel,
        setFilterModel,
        acg
    } = props;

    const acgID = (props.match && props.match.params.ACGId) || props.ACGId;

    const initializeGrid = (params) => {
        if (location?.state) {
            params.api.setFilterModel(location.state);
        }
    };

    const saveFilterModel = (params) => {
        setFilterModel(params.api.getFilterModel());
    };

    const [ , onGridReady ] = useAgGrid(initializeGrid);

    const acgSelected = (e) => {
        const { data } = e;
        history.push(`/admin/acg/${data.ACGId}`, filterModel);
    };

    const exportACGNumbers = () => {
        const headers = 'ACG Number,ACG Name,Created At,Created By\n';

        acg.sort((a, b) => sortAcgAlphaNumeric(a.ACGNumber, b.ACGNumber));
        const exportString = acg.reduce((acc, acgObj: ACGWithMappedUsers) => {
            acc += `"${acgObj.ACGNumber}","${acgObj.ACGName}","${formatEpochDate(acgObj.CreatedAt)}","${acgObj.CreatedByUsername}"\n`;

            return acc;
        }, headers);
        download('Lynq_Platform_ACG_Numbers.csv', exportString);
    };

    return (
        <div
            className={`ag-theme-material ${classes.root}`}
            id='acgNumbersGrid'
        >
            <ToolbarButton
                className={classes.exportButton}
                Icon={ExportIcon}
                iconClassName={classes.exportIcon}
                iconColor='rgba(0, 0, 0, 0.66)'
                id='acgNumbersExportButton'
                onClick={exportACGNumbers}
                text='Export'
            />
            <AgGridReact
                animateRows={false}
                columnDefs={ACGNumbersColumnDefs}
                columnMenu='legacy'
                defaultColDef={{
                    resizable: false,
                    filter: true,
                    sortable: true
                }}
                enableCellTextSelection={true}
                onFilterChanged={saveFilterModel}
                onGridReady={onGridReady}
                onRowClicked={acgSelected}
                rowData={acg}
                suppressCellFocus={true}
                suppressContextMenu={true}
            />
        </div>
    );
}